declare global {
  interface Window {
    config?: {
      VITE_BACKEND_BASE_URL?: string
      [key: string]: string | undefined
    }
  }
}

export const ENV_CONFIG = {
  VITE_BACKEND_BASE_URL: window.env?.API_URL || import.meta.env.VITE_BACKEND_BASE_URL || '',
}
